<template>
  <div class="body_main">
    <div class="box" ref="contentbox">
      <div class="header">
        <swiper :options="swiperOption" ref="mySwiper" v-if="scrollImg.length>=1">
          <swiper-slide class="swiper-img" v-for="(item,index) in scrollImg" :key="index">
            <img :src="item.ImgUrl" alt />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!-- <div class="content_stock">
      <div class="stock">
        <span class="tab_sh"></span>
        <p class="stock_title">股市解盘</p>
        <p class="stock_more" @click="jumpmore(newsdata.Art_UniqueUrl)">查看更多 >></p>
      </div>
      <div class="stock_main">
        <p class="stock_name">
          <span></span>
          {{ newsdata.Art_Author_Name }}
        </p>
        <p class="stock_num">{{ newsdata.Art_LKSPData }}</p>
        <p class="stock_date">{{ newsdata.time }}</p>
      </div>
      <div class="stock_info">
        <div class="marquee_box">
          <p v-if="isscroll==0">{{ newsdata.Art_Title }}</p>
          <ul v-else class="marquee_list" :class="{ marquee_top: animate }">
            <li v-for="item in marqueeList" :key="item.Art_Id">
              <p>{{ item.Art_Title }}</p>
            </li>
          </ul>
        </div>
      </div>
      </div>-->
      <div class="live" v-if="showLive">
        <div class="course">
          <span class="tab_sh"></span>
          <p class="course_title live_title">直播课程</p>
          <p class="course_more" @click="jumpLive">查看更多 >></p>
        </div>
        <div class="liver-wrapper">
          <ul>
            <li v-for="item in liveList" :key="item.channelId">
              <LiveCard
                :show-footer="false"
                :course-id="item.courseId"
                :channel-id="item.channelId"
                :notice-id="item.id"
                :img="item.image"
                :status="item.noticestatus"
                :type="item.courseType"
                :padding="false"
                :is-free="item.free"
              >
                <div slot="card-body">
                  <LiveSinal
                    v-if="item.noticestatus != 2"
                    :isLive="item.noticestatus == 1"
                    :heat="item.heatDegree"
                    :live-time="item.startTime && item.startTime.slice(11, 16)"
                  ></LiveSinal>
                </div>
              </LiveCard>
            </li>
          </ul>
        </div>
      </div>
      <div class="course_all">
        <div style="background-color:#fbfbfb">
          <div class="content_course">
            <div class="course">
              <span class="tab_sh"></span>
              <p class="course_title">最新上架</p>
              <p class="course_more" @click="jumpNew">查看更多 >></p>
            </div>
            <ul class="main">
              <li
                @click="getInfo(item.courseId)"
                v-for="item in newestCourseList"
                :key="item.courseId"
                style="position:relative;"
              >
                <div class="main_box">
                  <div>
                    <img
                      v-if="item.hot"
                      style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                      src="../../public/images/hot.png"
                      alt
                    />
                    <img
                      v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                      style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                      src="../../public/images/new.png"
                      alt
                    />
                  </div>
                  <div class="main_left">
                    <img :src="item.imageUrl" alt />
                  </div>
                  <div class="main_right">
                    <p class="video_name">{{item.name}}</p>
                    <p class="video_teacher">{{item.teacher}}</p>
                    <div class="img_tab">
                      <p v-for="(items,index) in item.labelList" :key="index">
                        <span>{{items}}</span>
                      </p>
                    </div>
                    <p class="video_all">
                      已有
                      <span>{{item.viewQuantity}}</span>人看过
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div style="background-color:#fbfbfb">
          <div class="content_course">
            <div class="course">
              <span class="tab_sh"></span>
              <p class="course_title">精品课程</p>
              <p class="course_more" @click="jumpBest">查看更多 >></p>
            </div>
            <ul class="main">
              <li
                @click="getInfo(item.courseId)"
                v-for="item in bestCourseList"
                :key="item.courseId"
                style="position:relative;"
              >
                <div class="main_box">
                  <div>
                    <img
                      v-if="item.hot"
                      style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                      src="../../public/images/hot.png"
                      alt
                    />
                    <img
                      v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                      style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                      src="../../public/images/new.png"
                      alt
                    />
                  </div>
                  <div class="main_left">
                    <img :src="item.imageUrl" alt />
                  </div>
                  <div class="main_right">
                    <p class="video_name">{{item.name}}</p>
                    <p class="video_teacher">{{item.teacher}}</p>
                    <div class="img_tab">
                      <p v-for="(items,index) in item.labelList" :key="index">
                        <span>{{items}}</span>
                      </p>
                    </div>
                    <p class="video_all">
                      已有
                      <span>{{item.viewQuantity}}</span>人看过
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div style="background-color:#fbfbfb">
          <div class="content_course">
            <div class="course">
              <span class="tab_sh"></span>
              <p class="course_title">热播课程</p>
              <p class="course_more" @click="jumpHot">查看更多 >></p>
            </div>
            <ul class="main">
              <li
                @click="getInfo(item.courseId)"
                v-for="item in hotCourseList"
                :key="item.courseId"
                style="position:relative;"
              >
                <div class="main_box">
                  <div>
                    <img
                      v-if="item.hot"
                      style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                      src="../../public/images/hot.png"
                      alt
                    />
                    <img
                      v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                      style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                      src="../../public/images/new.png"
                      alt
                    />
                  </div>
                  <div class="main_left">
                    <img :src="item.imageUrl" alt />
                  </div>
                  <div class="main_right">
                    <p class="video_name">{{item.name}}</p>
                    <p class="video_teacher">{{item.teacher}}</p>
                    <div class="img_tab">
                      <p v-for="(items,index) in item.labelList" :key="index">
                        <span>{{items}}</span>
                      </p>
                    </div>
                    <p class="video_all">
                      已有
                      <span>{{item.viewQuantity}}</span>人看过
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <Header />
  </div>
</template>
<script>
import Header from "../components/Header";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { QueryCmsNews, HomeCourses, getLiveList } from "../utils/http.js";
import LiveSinal from "@/components/LiveSignal";
import LiveCard from "@/components/LiveCard";
import { getCookie } from "@/utils/util";
// import cancelRequest from "../utils/util";
import jsonp from "jsonp";
// import emH5Share from "./emH5Share.js";
export default {
  name: "home",
  components: {
    Header,
    swiper,
    swiperSlide,
    LiveSinal,
    LiveCard
  },
  data() {
    return {
      swiperOption: {},
      n: 0,
      from: 1,
      animate: false,
      marqueeList: [],
      newsdata: [],
      oldsdata: [],
      isscroll: 0,
      bestCourseList: [],
      hotCourseList: [],
      newestCourseList: [],
      scrollImg: [],
      activeIndex: 0,
      date: new Date(),
      liveList: [],
      showLive: true,
      miniToken: ""
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    // setTimeout(() => {
    //   QueryCmsNews({ column: 1088, pageindex: 1, pagesize: 1 }).then(res => {
    //     if (res.Success) {
    //       this.newsdata = res.Result[0];
    //       if (this.oldsdata.Art_Id != res.Result[0].Art_Id) {
    //         this.newsdata = res.Result[0];
    //         this.newsdata.time = this.newsdata.Art_Showtime.slice(11, 16);
    //         this.marqueeList.push(this.oldsdata);
    //         this.marqueeList.push(this.newsdata);
    //         this.isscroll = 1;
    //         setTimeout(this.showMarquee, 500);
    //       }
    //     }
    //   });
    // }, 2000);

    this.iosRequest("emh5updatebackbtn:");
  },
  mounted() {
    this.showLive = getCookie("isPaidvideoLive");
    // emH5.ShareData = {
    //   title: "金牌课程",
    //   desc: "为您精选投资课程",
    //   link: window.location.href,
    //   // imgUrl: "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
    //   imgUrl: location.href.split("#")[0] + "images/wechatlogo.png",
    //   fail: function(res) {
    //     alert(JSON.stringify(res));
    //   }
    // };
    // emH5.Share();
    var that = this;
    window.AG.checkUserIsLogin(function(result) {
      if (result) {
        window.AG.getUserLoginSuccessData(function(json) {
          window.debuggeruid = json.uid;
        });
      }
    });
    window.AG.setTitle("金牌课程");
    this.homeCourse();
    this.getImgList();
    var that = this;
    this.swiperOption = {
      autoplayDisableOnInteraction: false,
      direction: "horizontal",
      initialSlide: 0,
      loop: true,
      autoplay: 2000,
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 1,
      pagination: ".swiper-pagination",
      paginationClickable: true, //轮播图中下标点显示
      onClick(swiper) {
        that.activeIndex = swiper.activeIndex;
        var length = that.scrollImg.length;
        var imgIndex = that.activeIndex % length;
        that.jumpCourse(that.scrollImg[imgIndex].SkipUrl);
      }
    };
    window.scrollTo(0, 0);
    this.getHeight();
    this.overscroll(document.querySelector(".box"));
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.addEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
    getLiveList({
      getPlayback: true,
      noticeStatus: 3,
      noticeType: 0,
      pageNum: 1,
      pageSize: 4
    }).then(res => {
      this.liveList = res.data.data[0].notices;
    });
    this.miniToken =
      this.$route.query.miniToken || localStorage.getItem("miniToken") || "";
    localStorage.setItem("miniToken", this.miniToken);
  },
  destroyed() {
    var ua = navigator.userAgent;
    var isios = ua.indexOf("OS") > -1;
    if (isios) {
      document.body.removeEventListener("touchmove", this.listenScroll, {
        passive: false
      });
    }
  },
  methods: {
    getHeight() {
      this.$refs.contentbox.scrollTop = 0;
      let heightWindow = window.innerHeight;
      let heightMain = heightWindow - 48;
      this.$refs.contentbox.style.height = heightMain + "px";
    },
    overscroll(el) {
      el.addEventListener("touchstart", function() {
        var top = el.scrollTop,
          totalScroll = el.scrollHeight,
          currentScroll = top + el.offsetHeight;
        if (top === 0) {
          el.scrollTop = 1;
        } else if (currentScroll === totalScroll) {
          el.scrollTop = top - 1;
        }
      });

      el.addEventListener("touchmove", function(evt) {
        if (el.offsetHeight < el.scrollHeight) {
          evt._isScroller = true;
        }
      });
    },
    listenScroll(evt) {
      if (!evt._isScroller) {
        evt.preventDefault();
      }
    },
    iosRequest: url => {
      var frame = document.createElement("iframe");
      frame.src = url;
      frame.style.display = "none";
      frame.width = 1;
      frame.height = 1;
      document.body.appendChild(frame);
      setTimeout(function() {
        frame.remove();
      }, 10000);
    },
    homeCourse() {
      HomeCourses({ from: 0 }).then(res => {
        if (res.data.code == 0) {
          this.bestCourseList = res.data.data.bestCourseList;
          this.hotCourseList = res.data.data.hotCourseList;
          this.newestCourseList = res.data.data.newestCourseList;
        }
      });
    },
    showMarquee: function() {
      this.animate = true;
      setTimeout(() => {
        this.marqueeList.push(this.marqueeList[0]);
        this.marqueeList.shift();
        this.animate = false;
      }, 500);
    },
    getInfo(v) {
      this.$router.push({
        path: "courseInfo",
        query: { courseId: v }
      });
    },
    jumpBest() {
      this.$router.push({ path: "/course", query: { n: 1, from: 0 } });
    },
    jumpHot() {
      this.$router.push({ path: "/course", query: { n: 3, from: 1 } });
    },
    jumpNew() {
      this.$router.push({ path: "/course", query: { n: 3, from: 2 } });
    },
    getNews() {
      QueryCmsNews({ column: 1088, pageindex: 1, pagesize: 20 }).then(res => {
        if (res.Success) {
          this.newsdata = res.Result[1];
          this.newsdata.time = this.newsdata.Art_Showtime.slice(11, 16);
          this.oldsdata = this.newsdata;
        }
      });
    },
    jumpmore(v) {
      window.location.href = v;
    },
    getImgList() {
      const url =
        process.env.VUE_APP_VERSION == "prod"
          ? "https://premiumapi.eastmoney.com/app"
          : "http://premiumtest.eastmoney.com/appapi";
      jsonp(
        url + "/api/TrialVersionAdvertising/Get?type=15",
        { name: "cb", param: "cb" },
        (err, data) => {
          if (err) {
            console.error(err.message);
          } else {
            this.scrollImg = data.Data;
          }
        }
      );
    },
    jumpCourse(v) {
      this.$router.push({
        path: "/courseInfo",
        query: { courseId: v }
      });
    },
    jumpLive() {
      this.$router.push({
        path: "/live"
      });
    },
    bodyScroll(event) {
      event.preventDefault();
    },
    stopScroll() {
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", this.bodyScroll, false);
    },
    startScroll() {
      document.body.style.overflow = ""; // 出现滚动条
      document.removeEventListener("touchmove", this.bodyScroll, false);
    },
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      // var hours =
      //   date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      // var minutes =
      //   date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      // var seconds =
      //   date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  transform: translate3d(0, 0, 0);
}
.box {
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.body_main {
  background-color: #fefefe;
}
.header {
  width: 100%;
  height: 3.32rem;
  margin-bottom: 0.14rem;
}
.swiper-container {
  width: 100%;
  height: 3rem;
  padding: 0.23rem 0;
}
.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 100%;
}
.swiper-slide:not(.swiper-slide-active) {
  transform: scale(0.9);
}

.swiper-img {
  height: 2.8rem;
  /* width: 5.2rem; */
  width: 6.56rem;
}
.swiper-img img {
  height: 2.8rem;
  width: 6.56rem;
}
.content_stock {
  width: 7.16rem;
  height: 2.12rem;
  padding: 0 0.12rem 0 0.21rem;
  margin-bottom: 0.9rem;
}
.stock,
.course {
  width: 7.16rem;
  height: 0.35rem;
  padding: 0.1rem 0.17rem 0;
  background-color: #fff;
}
.stock_title,
.course_title {
  float: left;
  line-height: 0.35rem;
  font-size: 0.29rem;
  color: #333333;
}
.tab_sh {
  float: left;
  width: 0.06rem;
  height: 0.29rem;
  background-color: #ea5504;
  vertical-align: text-top;
  margin-right: 0.1rem;
}
.stock_title span,
.course_title span {
  display: inline-block;
  width: 0.06rem;
  height: 0.29rem;
  background-color: #ea5504;
  vertical-align: text-top;
  margin-right: 0.1rem;
}
.stock_more,
.course_more {
  float: right;
  line-height: 0.35rem;
  font-size: 0.25rem;
  color: #999999;
}
.stock_main {
  width: 7.16rem;
  height: 0.65rem;
}
.stock_name span,
.course_name span {
  display: inline-block;
  width: 0.12rem;
  height: 0.12rem;
  background-color: #ea5504;
  margin-right: 0.1rem;
  border-radius: 50%;
  border: 1px solid #f5dfd3;
}
.stock_name,
.stock_num {
  float: left;
  line-height: 0.65rem;
  font-size: 0.24rem;
}
.stock_num {
  margin-left: 0.2rem;
}
.stock_date {
  float: right;
  line-height: 0.65rem;
  font-size: 0.2rem;
  color: #999999;
}
.stock_info {
  width: 6.36rem;
  height: 0.74rem;
  margin: 0 auto;
  background-color: #efefef;
  padding: 0.18rem 0.18rem 0.21rem 0.24rem;
}
.stock_info p {
  line-height: 0.38rem;
  font-size: 0.25rem;
  overflow: hidden;
  color: #333333;
  text-align: left;
}
.content_course {
  width: 7.5rem;
  padding-bottom: 0.39rem;
  margin: 0 auto;
}
.main {
  /* width: 7.16rem; */
  background-color: #fff;
  /* padding: 0 0.17rem; */
}
.main li {
  width: 7.5rem;
}
.main_box {
  width: 7.07rem;
  margin: 0 auto;
  border-bottom: 1px solid #efefef;
  overflow: hidden;
}
.main_left {
  float: left;
  width: 3.33rem;
  height: 2.1rem;
  padding: 0.25rem 0.06rem;
}
.main_left img {
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
}
.main_right {
  float: right;
  width: 3.5rem;
}
.video_name {
  line-height: 0.57rem;
  font-size: 0.35rem;
  margin-top: 0.25rem;
  text-align: left;
  color: #333333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.video_teacher {
  line-height: 0.35rem;
  font-size: 0.25rem;
  text-align: left;
  color: #666666;
}
.img_tab {
  width: 3.5rem;
  /* margin: 0.3rem 0 0.42rem; */
  margin: 0.3rem 0;
  overflow: hidden;
  height: 0.46rem;
}
.img_tab p {
  float: left;
  margin-bottom: 0.1rem;
  margin-left: 0.1rem;
  transform: scale(2);
  transform-origin: left bottom;
}
.img_tab p:first-child {
  margin-left: 0;
}
.img_tab p span {
  display: block;
  transform: scale(0.5);
  transform-origin: left bottom;
  border: 1px solid #ea5503;
  text-align: center;
  border-radius: 30px 30px;
  font-size: 0.2rem;
  color: #ea5503;
  padding: 0.04rem 0.1rem;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  line-height: normal;
}
.video_all {
  text-align: right;
  width: 3.1rem;
  height: 0.42rem;
  line-height: 0.42rem;
  font-size: 0.25rem;
  color: #999999;
  margin-bottom: 0.1rem;
}
.course_all {
  width: 100%;
}
/*  */
.marquee_box {
  display: block;
  position: relative;
  width: 100%;
  height: 0.74rem;
  overflow: hidden;
}

.marquee_list {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}
.marquee_top {
  transition: all 0.8s;
  margin-top: -0.74rem;
}

.marquee_list li {
  height: 0.74rem;
}
.main li:last-child .main_box {
  border: none;
}
.live .course span {
  background-color: #046bea;
}
.liver-wrapper {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.liver-wrapper ul {
  /* width: 7rem !important; */
  /* margin: 0 20px; */
  display: flex;
  width: 13.4rem;
  padding: 0 0.2rem;
}
.liver-wrapper li {
  background: #ffffff;
}
</style>
<style scoped>
/*  */
/deep/.swiper-pagination {
  /* top: 78px; */
  bottom: 8px;
}
/deep/ .swiper-pagination .swiper-pagination-bullet {
  display: inline-block;
  width: 0.35rem !important;
  height: 0.04rem;
  border-radius: 0;
}
/deep/ .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #fff !important;
}
/deep/ .card-body {
  width: 3.3rem;
  height: 2rem !important;
  padding-top: 0 !important;
  background-size: 100% 100%;
  background-position: 0 0 !important;
}
</style>
